import { render, staticRenderFns } from "./WiseContentV2.vue?vue&type=template&id=92cb278e&scoped=true"
import script from "./WiseContentV2.vue?vue&type=script&lang=js"
export * from "./WiseContentV2.vue?vue&type=script&lang=js"
import style0 from "./WiseContentV2.vue?vue&type=style&index=0&id=92cb278e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cb278e",
  null
  
)

export default component.exports